import styled from "styled-components";

export const LogoContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px;
`;

export const LogoImage = styled.img`
  height: 240px;
  background-image: url("${(props) => props.src}");
  padding-top: 50px;

  @media screen and (max-width: 794px) {
    height: 150px;
  }
`;
